<template>
  <div class="algodep">
    <menuBox :step="1"></menuBox>
    <div class="algodep-box">
      <div class="banner-text">
        <div class="title">創新技術，連結未來</div>
        <div class="text">
          引領資訊時代，塑造智慧網路解決方案
        </div>
        <div class="btn" @click="step">
          了解詳情
        </div>
      </div>
    </div>
    <div class="type-box">
      <div class="typeTop">
        <p>全方位IT服務體系</p>
        <span @click="step">查看更多</span>
      </div>
      <div class="list">
        <div class="item">
          <img src="../assets/type1.png" alt="">
          <p>軟體開發</p>
          <span>客製化軟體解決方案，滿足企業多樣化需求。</span>
        </div>
        <div class="item">
          <img src="../assets/type2.png" alt="">
          <p>系統整合服務</p>
          <span>優化IT架構，提升系統效率與互通性。</span>
        </div>
        <div class="item">
          <img src="../assets/type3.png" alt="">
          <p>網路安全管理</p>
          <span>強化資料保護，確保業務營運的安全性。</span>
        </div>
      </div>
    </div>
    <div class="client-box">
      <img src="../assets/client.png" alt="" class="clientImg">
      <div class="clientRight">
        <div class="title">為什麼選擇我們？</div>
        <div class="text">我們透過領先的技術創新、客製化解決方案、堅實的安全保障以及專業團隊支持，贏得客戶的信賴和選擇。</div>
        <div class="lineBox">
          <div class="item">
            <img src="../assets/client1.png" alt="">
            <div>
              <p>技術創新領先</p>
              <span>採用最新技術，推動業務成長。</span>
            </div>
          </div>
          <div class="item">
            <img src="../assets/client2.png" alt="">
            <div>
              <p>解決方案客製化</p>
              <span>依客戶需求量身訂做服務。</span>
            </div>
          </div>
        </div>
        <div class="lineBox">
          <div class="item">
            <img src="../assets/client3.png" alt="">
            <div>
              <p>安全性優先</p>
              <span>嚴格的資料保護和風險管理。</span>
            </div>
          </div>
          <div class="item">
            <img src="../assets/client4.png" alt="">
            <div>
              <p>專業團隊支持</p>
              <span>由經驗豐富的專家提供持續支援。</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="plan-box">
      <div class="bt">專業是我們的態度</div>
      <div class="plan-content">
        <div class="planLeft">
          <img src="../assets/plan1.png" alt="">
        </div>
        <div class="planRight">
          <div class="lineBox">
            <img src="../assets/plan2.png" alt="">
            <img src="../assets/plan3.png" alt="">
          </div>
          <div class="lineBox">
            <img src="../assets/plan4.png" alt="">
            <img src="../assets/plan5.png" alt="">
          </div>
        </div>
      </div>
    </div>
    <div class="develop-box">
      <div class="title">科技驅動發展</div>
      <div class="text">我們結合尖端技術、安全架構和敏捷開發，為客戶提供創新且可靠的IT解決方案。</div>
      <div class="develop-content">
        <div class="left">
          <div class="item">
            <img src="../assets/develop1.png" alt="">
            <div>
              <p>尖端技術應用</p>
              <span>運用AI、大數據分析，驅動業務智慧化與自動化。</span>
            </div>
          </div>
          <div class="item">
            <img src="../assets/develop2.png" alt="">
            <div>
              <p>高效安全架構</p>
              <span>建構強大的網路防護，確保資料安全和業務連續性。</span>
            </div>
          </div>
          <div class="item">
            <img src="../assets/develop3.png" alt="">
            <div>
              <p>敏捷開發模式</p>
              <span>採用敏捷開發策略，快速回應市場變化，提升產品迭代效率。</span>
            </div>
          </div>
        </div>
        <img src="../assets/develop.png" class="developImg" alt="">
      </div>
    </div>
    <footerBox></footerBox>
  </div>
</template>

<script>
import footerBox from "@/components/footer";
import menuBox from "@/components/menu";

export default {
  name: "App",
  components: {
    menuBox,
    footerBox,
  },
  data() {
    return {
      type: 1
    };
  },
  mounted() { },
  methods: {
    step() {
      this.$router.push({ path: "aboutUs" });
    }
  },
};
</script>

<style lang="less" scoped>
.algodep-box {
  background-image: url(../assets/about1.png);
  height: 784px;
  background-size: 100% 100%;
  position: relative;

  .banner-text {
    margin-left: 360px;
    padding-top: 279px;
    width: 723px;

    .title {
      width: 400px;
      margin-bottom: 20px;
      font-size: 54px;
      font-family: PingFang SC, PingFang SC;
      font-weight: 600;
      color: #333333;
      line-height: 63px;
    }

    .text {
      width: 450px;
      margin-bottom: 35px;
      font-size: 28px;
      font-family: PingFang SC, PingFang SC;
      font-weight: 400;
      color: #333333;
      line-height: 32px;
    }

    .btn {
      cursor: pointer;
      display: inline-block;
      font-size: 16px;
      font-family: Arial, Arial;
      font-weight: normal;
      color: #FFFFFF;
      padding: 13px 40px;
      background: rgba(44, 133, 250, 1);
      border-radius: 47px;
    }
  }
}

.type-box {
  padding: 150px 360px;

  .typeTop {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 70px;

    p {
      width: 395px;
      font-size: 40px;
      font-family: PingFang SC, PingFang SC;
      font-weight: 600;
      color: #333333;
      line-height: 48px;
    }

    span {
      cursor: pointer;
      padding: 14px 40px;
      background-color: rgba(44, 133, 250, 1);
      font-size: 24px;
      font-family: Inter, Inter;
      font-weight: 400;
      color: #FFFFFF;
    }
  }

  .list {
    display: flex;

    .item {
      margin-right: 36px;
      padding: 40px 20px;
      background: #FFFFFF;
      box-shadow: 3px 1px 44px 0px rgba(200, 216, 223, 0.47);
      box-sizing: border-box;

      img {
        margin-bottom: 33px;
        width: 72px;
        height: 72px;
      }

      p {
        margin-bottom: 16px;
        font-size: 24px;
        font-family: PingFang SC, PingFang SC;
        font-weight: 600;
        color: #4D4D4D;
      }

      span {
        font-size: 18px;
        font-family: PingFang SC, PingFang SC;
        font-weight: 400;
        color: #7D7D7D;
        line-height: 27px;
      }
    }

    .item:nth-child(3) {
      margin-right: 0;
    }
  }
}

.client-box {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 360px 150px;

  .clientImg {
    margin-right: 86px;
    width: 407px;
    height: 424px;
  }

  .clientRight {
    .title {
      margin-bottom: 24px;
      font-size: 40px;
      font-family: PingFang SC, PingFang SC;
      font-weight: 600;
      color: #333333;
    }

    .text {
      margin-bottom: 40px;
      font-size: 24px;
      font-family: PingFang SC, PingFang SC;
      font-weight: 400;
      color: #999999;
    }

    .lineBox {
      display: flex;
      margin-bottom: 82px;

      .item {
        width: 50%;
        display: flex;
        align-items: center;
        margin-right: 47px;

        img {
          margin-right: 32px;
          width: 72px;
          height: 72px;
        }

        p {
          margin-bottom: 10px;
          font-size: 28px;
          font-family: PingFang SC, PingFang SC;
          font-weight: 400;
          color: #333333;
        }

        span {
          font-size: 18px;
          font-family: PingFang SC, PingFang SC;
          font-weight: 400;
          color: #999999;
          line-height: 21px;
        }
      }

      .item:nth-child(2) {
        margin-right: 0;
      }
    }
  }
}

.plan-box {
  padding: 0 360px 160px;

  .bt {
    text-align: center;
    margin: 0 auto 70px;
    width: 360px;
    font-size: 40px;
    font-family: PingFang SC, PingFang SC;
    font-weight: 600;
    color: #333333;
    line-height: 48px;
  }

  .plan-content {
    display: flex;

    .planLeft {
      margin-right: 24px;

      img {
        width: 384px;
        height: 502px;
      }
    }

    .planRight {
      .lineBox {
        display: flex;

        img {
          margin: 0 24px 18px 0;
          width: 384px;
          height: 242px;
        }

        .img:nth-child(2) {
          margin-right: 0;
        }
      }
    }
  }
}

.develop-box {
  padding: 0 360px 120px;

  .title {
    margin-bottom: 20px;
    width: 360px;
    font-size: 40px;
    font-family: PingFang SC, PingFang SC;
    font-weight: 600;
    color: #333333;
  }

  .text {
    font-size: 24px;
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    color: #999999;
  }

  .develop-content {
    display: flex;
    align-items: center;
    justify-content: space-between;

    .developImg {
      width: 654px;
      height: 476px;
    }

    .left {
      margin-right: 98px;

      .item {
        display: flex;
        align-items: center;
        margin-bottom: 40px;

        img {
          margin-right: 32px;
          width: 72px;
          height: 72px;
        }

        p {
          margin-bottom: 12px;
          font-size: 28px;
          font-family: PingFang SC, PingFang SC;
          font-weight: 400;
          color: #333333;
        }

        span {
          font-size: 18px;
          font-family: PingFang SC, PingFang SC;
          font-weight: 400;
          color: #999999;
          line-height: 21px;
        }
      }
    }
  }
}
</style>
